import React from 'react';
import { ToastMessageProvider } from './src/contexts/ToastMessageContext';

export const wrapRootElement = ({ element }) => {
  return (
    <ToastMessageProvider>
      {element}
    </ToastMessageProvider>
  );
}; 